import React from 'react';
// import { StyledInput, StyledLabel, InputWrapper, ErrorMessage } from './AuthInput.styles';
import styles from './AuthInput.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AuthPassInputField = ({
    type = 'text',
    label,
    name,
    value,
    onChange,
    placeholder,
    error,
    required = false,
    icon,
    onIconClick,
    className = '',
    ...props
}) => {
    return (
        <div className={`${styles.inputContainer} ${className}`}>
            {label && (
                <label htmlFor={name} className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            )}

            <div className={styles.inputWrapperPassword}>
                <input
                    id={name}
                    type={type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className={`${styles.inputPassword} ${error ? styles.error : ''}`}
                    {...props}
                />

                {icon && (
                    // <button
                    //   type="button"
                    //   className={styles.iconButton}
                    //   onClick={onIconClick}
                    //   aria-label={type === 'password' ? 'Toggle password visibility' : ''}
                    // >
                    //   <FontAwesomeIcon icon={icon} className={styles.icon} />
                    // </button>

                    <FontAwesomeIcon icon={icon} onClick={onIconClick} className={styles.icon} />

                )}
            </div>

            {error && <span className={styles.errorMessage}>{error}</span>}
        </div>
    );
};
export default AuthPassInputField;